<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <v-card>
      <v-card-title class="color-a">
        Information om status
      </v-card-title>
      <v-card-text>
        <h3>
          Opublicerat möte:
        </h3>
        <p>
          När mötet är opublicerat så syns det inte för medlemmar. Du kan
          förbereda och lägga in medlemmar och dagordning utan att någon ser att
          du ändrar.
        </p>
        <h3>
          1. Publicerat möte:
        </h3>
        <p>
          När du är klar med dina förberedelser så ändrar du status till "Möte
          publicerat". Nu kan medlemmarna se mötet i appen. Notera att du inte
          kan publicera ett möte med fler än 5 medlemmar om du inte angivit en
          betalmetod. Möjlighet att sätta betalmetod finns i mötets
          inställningar.
        </p>
        <h3>
          2. Öppna närvaroregistrering:
        </h3>
        <p>
          Precis som på en vanlig föreningsstämma behöver de närvarande räknas
          in och få en röstsedel. Detta sker digitalt vid närvaroregistreringen.
          Vi rekommenderar att ni öppnar närvaroregistrering ca 30 minuter innan
          utsatt start på mötet.
        </p>
        <h3>
          3. Öppna möte:
        </h3>
        <p>
          När ni vill sätta igång mötet väljer ni status "Möte öppnat". Nu kan
          de medlemmar som registrerat närvaro i appen se vilken som är den
          aktiva punkten på dagordningen. Det är i detta läget ni aktiverar
          dagordningspunkter och beslut, samt ser hur medlemmarna röstar.
        </p>
        <h3>
          4. Stäng möte:
        </h3>
        <p>
          När mötet är över sätter ni status "Stäng möte". När ni gör detta
          kommer ni debiteras via det på mötet angivna betalmedel. När mötet väl
          är stängt kommer ni kunna ladda ner mötesrapporten som ni kan skriva
          ut och lägga till ert protokoll som stöd för röstningsunderlaget.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Stäng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  mounted() {
    this.$root.$on("openStatusInformationModal", () => {
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style></style>
